import React, { ReactNode, useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  Drawer,
  IconButton,
  Paper,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router";

import SidebarContent from "./SidebarContent";
// import DttHeader from "./DttHeader";
import logo from "../images/admin.png";
import {
  Camera,
  CameraAltOutlined,
  CameraAltRounded,
  SpaceBar,
} from "@mui/icons-material";
import DttTableData from "@/components/DttTableData";
import DttFooter from "./DttFooter";
import BreadcrumbsComponent from "./BreadcrumbsComponent";
import NotificationBell from "./Notification";
import { CustomBreadcrumbProvider } from "@/contexts/CustomBreadcrumb";
// import { useUser } from "@/contexts/UserContext";
import { relative } from "path";
import { apiRemote } from "@/api";
import { useAlert } from "@/contexts/AlertContext";
import Chatbox from "./Chatbox";
import he from 'he';
import { MenuIcon } from "lucide-react";
import EducatorRegisterHeader from "./EducatorRegisterHeader";
import TCCDeadlineBanner from "./TCCDeadlineBanner";

interface LayoutProps {
  children: ReactNode;
}
const size = 160;
const EducatorRegisterLayout = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  const [sidebarOpen, setSidebarOpen] = useState(!isMobile)

  const toggleSidebar = () => {
    console.log(123)
    setSidebarOpen(!sidebarOpen)
  }

  useEffect(() => {
    setSidebarOpen(!isMobile)
  }, [isMobile])
  return (
    <>
      {/* <CustomBreadcrumbProvider> */}
        {/* <Container maxWidth="xl"> */}
        <Box
          sx={{
            // backgroundColor: "#f0f7ff",
            backgroundColor: "#f8fafc",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CssBaseline />
          <EducatorRegisterHeader />
          <TCCDeadlineBanner />
          <Box display="flex" minHeight="100vh" flexDirection="column">
            {/* <AdminHeader /> */}
            <Box
              sx={{
                display: "flex",
                flex: 1,
                borderTop: "1px solid #ddd",
                // marginTop: "1.5rem",
              }}
            >
              <Box
                component="main"
                sx={{
                  flex: 1,
                  overflow: "hidden",
                  // p: { xs: 1, md: 3 },
                }}
              >
                <Paper
                  sx={{
                    // mb: 2,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    background: "unset",
                    boxShadow: "unset",
                  }}
                >
                  <Outlet />
                </Paper>
              </Box>
            </Box>
          </Box>

          <DttFooter />
        </Box>
      {/* </CustomBreadcrumbProvider> */}
      {/* </Container> */}
    </>
  );
};

export default EducatorRegisterLayout;
